import React, { useState, useContext } from 'react';
import { Form, Button, Header, Message } from 'semantic-ui-react';
import UserContext from 'contexts/UserContext';

const PasswordSettings = () => {
  const appUser = useContext(UserContext);
  const [ form, setForm ] = useState({
    current: '',
    newPassword: '',
    verifyNewPassword: '',
  });
  const [ message, setMessage ] = useState();
  const [ saving, setSaving ] = useState(false);

  const handleFormInputChange = (e, { name, value }) => {
    setForm({...form, [name]: value });
  };

  const isValid = form.current.length > 0 && form.newPassword.length > 0 && form.newPassword === form.verifyNewPassword;

  const handleFormSubmit = async () => {
    setSaving(true);
    try {
      const res = await appUser.updatePassword(form.current, form.newPassword);
      console.log(res);
      setForm({
        current: '',
        newPassword: '',
        verifyNewPassword: '',
      });
      setMessage({
        success: true,
        content: 'Password updated successfully.'
      });
    } catch (e) {
      setMessage({
        error: true,
        content: e.message
      });
    }
    setSaving(false);
  };

  console.log(message);

  return (
    <React.Fragment>
      <Header as="h3">Password Settings
        <Header.Subheader>Passwords must be at least 8 characters and must contain at least one uppercase letter, one lowercase letter, and one number.</Header.Subheader>
      </Header>

      {message ? (<Message {...message} />) : null }

      <Form onSubmit={handleFormSubmit}>

        <Form.Input
          fluid
          icon='lock'
          name='current'
          iconPosition='left'
          label='Current Password'
          value={form.current}
          type='password'
          onChange={handleFormInputChange}
        />
        <Form.Input
          fluid
          icon='lock'
          name='newPassword'
          iconPosition='left'
          label='New Password'
          value={form.newPassword}
          type='password'
          onChange={handleFormInputChange}
        />
        <Form.Input
          fluid
          icon='lock'
          name='verifyNewPassword'
          iconPosition='left'
          label='Verify New Password'
          value={form.verifyNewPassword}
          type='password'
          onChange={handleFormInputChange}
        />
        <Form.Field>
          <Button
            loading={saving}
            disabled={!isValid}
            type="submit"
            basic
            primary
          >
            Update
          </Button>
          <Button
            type="button"
            basic
            onClick={() => {
              setMessage();
              setForm({
                current: '',
                newPassword: '',
                verifyNewPassword: ''
              });
            }}
          >
            Cancel
          </Button>
        </Form.Field>
      </Form>
    </React.Fragment>
  );
}

export default PasswordSettings;
